export enum ComponentTypeEnum {
  Dropdown = 'Dropdown',
  MultiSelectDropdown = 'MultiSelectDropdown',
  TreeDropdown = 'TreeDropdown',
}
